var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],attrs:{"infinite-scroll-disabled":_vm.disabled,"infinite-scroll-distance":_vm.distance}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }